<div class="container p-4">
    <div class="card border-0 shadow-sm mb-3 py-1 px-4">
        <dx-toolbar class="theme-dependent">
            <dxi-item location="before">
                <div class="header-text">{{ assetId ? 'Edit Asset' : 'New Asset' }}</div>
            </dxi-item>
            <dxi-item location="after" locateInMenu="never">
                <dx-button
                    text="Cancel"
                    stylingMode="outlined"
                    type="normal"
                    (onClick)="cancel()"
                >
                </dx-button>
            </dxi-item>
            <dxi-item location="after" locateInMenu="never">
                <dx-button
                    text="Save"
                    icon="save"
                    type="default"
                    stylingMode="contained"
                    [disabled]="isSubmitting"
                    (onClick)="save()"
                >
                </dx-button>
            </dxi-item>
        </dx-toolbar>
    </div>

    <dx-load-panel
        container=".view-wrapper-scroll"
        [visible]="isLoading"
        [showPane]="false"
        [position]="{ of: 'asset-details' }"
    >
    </dx-load-panel>

    <dx-scroll-view class="view-wrapper-scroll">
        <dx-validation-group #validationGroup>
            @if (!isLoading) {
                <div class="form-container">
                    <div class="card border-0 shadow-sm pt-0 pb-4 mb-4">
                        <div class="card-header fs-5 fw-medium d-flex justify-content-between">
                            <div>General Information</div>
                            @if (asset.code) {
                                <div>
                                    <strong>ID:</strong>
                                    <span class="text-muted">
                                    {{ asset.code }}
                                </span>
                                </div>
                            }
                        </div>
                        <div class="card-body">
                            <div class="row g-3">
                                <div class="col-md-4">
                                    <label class="form-label">Condition <span class="text-danger">*</span></label>
                                    <dx-select-box
                                        [(value)]="asset.condition"
                                        [items]="assetConditionOptions"
                                        valueExpr="value"
                                        displayExpr="text"
                                        stylingMode="filled"
                                        placeholder="Select Condition"
                                    >
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Condition is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Classification <span class="text-danger">*</span></label>
                                    <dx-select-box
                                        [(value)]="asset.classification"
                                        [items]="assetClassificationOptions"
                                        valueExpr="value"
                                        displayExpr="text"
                                        stylingMode="filled"
                                        placeholder="Select Classification"
                                    >
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Classification is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Type <span class="text-danger">*</span></label>
                                    <dx-select-box
                                        [(value)]="asset.type"
                                        [items]="assetTypeOptions"
                                        valueExpr="value"
                                        displayExpr="text"
                                        stylingMode="filled"
                                        placeholder="Select Type"
                                        [searchEnabled]="true"
                                    >
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Type is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Tag ID (NET ID)</label>
                                    <dx-text-box
                                        [(value)]="asset.tagId"
                                        stylingMode="filled"
                                        placeholder="Enter Tag ID"
                                    >
                                        <dx-validator>
                                            <dxi-validation-rule type="stringLength" [max]="50"
                                                                 message="Max 50 characters"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Brand <span class="text-danger">*</span></label>
                                    <dx-text-box
                                        [(value)]="asset.brand"
                                        stylingMode="filled"
                                        placeholder="Enter Brand"
                                    >
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Brand is required"></dxi-validation-rule>
                                            <dxi-validation-rule type="stringLength" [max]="100"
                                                                 message="Max 100 characters"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Model</label>
                                    <dx-text-box
                                        [(value)]="asset.model"
                                        stylingMode="filled"
                                        placeholder="Enter Model"
                                    >
                                        <dx-validator>
                                            <dxi-validation-rule type="stringLength" [max]="100"
                                                                 message="Max 100 characters"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Serial</label>
                                    <dx-text-box
                                        [(value)]="asset.serial"
                                        stylingMode="filled"
                                        placeholder="Enter Serial"
                                    >
                                        <dx-validator>
                                            <dxi-validation-rule type="stringLength" [max]="100"
                                                                 message="Max 100 characters"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Business Unit Location</label>
                                    <dx-text-box
                                        [(value)]="asset.businessUnitLocation"
                                        stylingMode="filled"
                                        placeholder="Enter Location"
                                    >
                                        <dx-validator>
                                            <dxi-validation-rule type="stringLength" [max]="200"
                                                                 message="Max 200 characters"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Ownership <span class="text-danger">*</span></label>
                                    <dx-select-box
                                        [(value)]="asset.ownership"
                                        [items]="assetOwnershipOptions"
                                        valueExpr="value"
                                        displayExpr="text"
                                        stylingMode="filled"
                                        placeholder="Select Ownership"
                                    >
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Ownership is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                            </div>
                        </div>
                    </div>

                    @if (showOwnershipInfo) {
                        <div class="card border-0 shadow-sm pt-0 pb-4 mb-4">
                            <div class="card-header fs-5 fw-medium">Ownership Info</div>
                            <div class="card-body">
                                <div class="row g-3">
                                    <div class="col-md-6">
                                        <label class="form-label">Agreement #</label>
                                        <dx-text-box
                                            [(value)]="asset.ownershipInfo!.agreement"
                                            stylingMode="filled"
                                            placeholder="Enter Agreement"
                                        ></dx-text-box>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Vendor</label>
                                        <dx-text-box
                                            [(value)]="asset.ownershipInfo.vendor"
                                            stylingMode="filled"
                                            placeholder="Enter Vendor"
                                        ></dx-text-box>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Effective Date <span class="text-danger">*</span></label>
                                        <dx-date-box
                                            [(value)]="asset.ownershipInfo!.effectiveDate"
                                            stylingMode="filled"
                                            [useMaskBehavior]="true"
                                            displayFormat="MM/dd/yyyy"
                                        >
                                            <dx-validator>
                                                <dxi-validation-rule type="required" message="Effective Date is required"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-date-box>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">End Date</label>
                                        <dx-date-box
                                            [(value)]="asset.ownershipInfo!.endDate"
                                            stylingMode="filled"
                                            [useMaskBehavior]="true"
                                            displayFormat="MM/dd/yyyy"
                                        ></dx-date-box>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    @if (showAttachments) {
                        <div class="card border-0 shadow-sm pt-0 pb-4 mb-4">
                            <div class="card-header fs-5 fw-medium">Attachments</div>
                            <div class="card-body">
                                <div class="row g-3">
                                    @if (showMobileLabelPrinter) {
                                        <div class="col-md-6">
                                            <app-asset-attachment-selector
                                                label="Mobile Label Printer"
                                                [(value)]="asset.attachments!.mobileLabelPrinterId"
                                                [dataSource]="printerOptionsDataSource"
                                                [required]="true"
                                            ></app-asset-attachment-selector>
                                        </div>
                                    }

                                    @if (showRfScanGun) {
                                        <div class="col-md-6">
                                            <app-asset-attachment-selector
                                                label="RF Scan Gun"
                                                [(value)]="asset.attachments!.rfScanGunId"
                                                [dataSource]="scannerOptionsDataSource"
                                                [required]="true"
                                            ></app-asset-attachment-selector>
                                        </div>
                                    }

                                    @if (showMheBattery) {
                                        <div class="col-md-6">
                                            <app-asset-attachment-selector
                                                label="MHE Battery"
                                                [(value)]="asset.attachments!.mheBatteryId"
                                                [dataSource]="batteryOptionsDataSource"
                                                [required]="true"
                                            ></app-asset-attachment-selector>
                                        </div>
                                    }

                                    @if (showTabletComputer) {
                                        <div class="col-md-6">
                                            <app-asset-attachment-selector
                                                label="Tablet Computer"
                                                [(value)]="asset.attachments!.tabletComputerId"
                                                [dataSource]="tabletOptionsDataSource"
                                                [required]="tabletComputerRequired"
                                            ></app-asset-attachment-selector>
                                        </div>
                                    }

                                    @if (showClampLayerAttach) {
                                        <div class="col-md-6">
                                            <app-asset-attachment-selector
                                                label="Clamp Layer Attach"
                                                [(value)]="asset.attachments!.clampLayerAttachId"
                                                [dataSource]="clampOptionsDataSource"
                                                [required]="true"
                                            ></app-asset-attachment-selector>
                                        </div>
                                    }

                                    @if (showSlipSheetAttach) {
                                        <div class="col-md-6">
                                            <app-asset-attachment-selector
                                                label="Slip Sheet Attach"
                                                [(value)]="asset.attachments!.slipSheetAttachId"
                                                [dataSource]="slipSheetAttachDataSource"
                                                [required]="false"
                                            ></app-asset-attachment-selector>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }

                    @if (authService.checkPermission(PermissionType.Assets, AccessType.ViewOnly)) {
                        <app-notes
                            [entityId]="assetId"
                            [noteType]="NoteType.Asset"
                            [canCreate]="authService.checkPermission(PermissionType.Assets, AccessType.Manage)"
                        ></app-notes>
                    }
                </div>
            }
        </dx-validation-group>
    </dx-scroll-view>
</div>
